import { prefersReducedMotion } from "@js/parts/prefersReducedMotion";

export default (config = {}) => ({
  speed: config.speed || 0.1,

  x: 0,
  y: 0,
  targetX: 0,
  targetY: 0,

  animationFrame: null,
  container: null,

  init() {
    if (prefersReducedMotion()) return;

    this.container = this.$el.closest("[data-mouse-container]");
    this.animate();

    if (this.container) {
      this.container.addEventListener(
        "mousemove",
        this.handleMouseMove.bind(this)
      );
    }
  },

  handleMouseMove(e) {
    const rect = this.container.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    const elRect = this.$el.getBoundingClientRect();
    const elWidth = elRect.width;
    const elHeight = elRect.height;

    this.targetX = x - elWidth / 2;
    this.targetY = y - elHeight / 2;
  },

  animate() {
    this.x += (this.targetX - this.x) * this.speed;
    this.y += (this.targetY - this.y) * this.speed;

    this.animationFrame = requestAnimationFrame(() => this.animate());
  },

  destroy() {
    if (this.animationFrame) {
      cancelAnimationFrame(this.animationFrame);
    }
    if (this.container) {
      this.container.removeEventListener("mousemove", this.handleMouseMove);
    }
  },
});
